import AxiosService from '@/api/ApiBase';
import { ShortParty } from '@/types/organization/partners/response';
import { DatePeriod, DatePeriodRange } from '@/types/common/dateRange.model';
import { DatePeriods } from '@/constants/reports';

export interface ReportCustomerEntity {
  customer: ShortParty;
  isPending?: boolean;
  isFinalize?: boolean;
  status?: {
    code: string;
    description: string;
  };
}

export interface GetCourierCustomersPayload {
  frequency: DatePeriods;
  period?: DatePeriodRange;
  month?: string;
  day?: string;
}

class ReportsCustomerService {
  getWarehouseCustomers(period: DatePeriod) {
    return AxiosService.get<{ message: string; data: ReportCustomerEntity[] }>(
      `warehouse/reports/commissions/warehouse/customers`,
      { params: { period } }
    );
  }

  getCommissionCustomers(period: DatePeriod) {
    return AxiosService.get<{ message: string; data: ReportCustomerEntity[] }>(
      `warehouse/reports/commissions/customers`,
      { params: { period } }
    );
  }

  getCourierCustomers(payload: GetCourierCustomersPayload) {
    return AxiosService.post<{ message: string; data: ReportCustomerEntity[] }>(
      `warehouse/reports/courier/customers`,
      payload
    );
  }

  static getWarehouseCourierCustomers(payload: WarehouseCustomerPayload) {
    return AxiosService.post('/warehouse/reports/courier/customers', payload);
  }
}

export default new ReportsCustomerService();
